import { run } from 'RUNTIME'; run(() => import('INNER'))